// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>25</span>&nbsp;&nbsp;Come, O Lord, and save us we pray.&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;Come, Lord, send us now prosperity.<br> </p> </div></div>";
// Exports
module.exports = code;